module.exports = __webpack_public_path__ + "static/media/S2N5-2.124d127e.svg";